import { Size2MixExpandCollapseBar, Size2MixSection, Size2MixSimpleTable, TEST_PUC_PRODUCTION, useSectionsToggle } from '@shared/size2mix-shell';
import type { OptimisationDetail } from './types';

const SECTIONS = ['production', 'pumps', 'fuels'] as const;
const SNAPSHOT_UNITS = [
    { site: 'Chaufferie biomasse', name: 'Chaudière biomasse', priority: 1, fuelContract: 'Centrale_Default', defaultPrice: '1' },
    { site: 'Chaufferie gaz', name: 'Chaudière gaz', priority: 22, fuelContract: '-', defaultPrice: '1, 1' },
    { site: 'Chaufferie biomasse', name: 'Chaudière 2', priority: 7, fuelContract: 'Contrat gaz', defaultPrice: '1' },
];

export default function SynthesisTab({ detail }: { detail: OptimisationDetail }) {
    const { bind, expandAll, collapseAll } = useSectionsToggle(SECTIONS);
    return (
        <>
            <Size2MixExpandCollapseBar onExpandAll={expandAll} onCollapseAll={collapseAll}><span>Synthèse du réseau au lancement de l'optimisation</span></Size2MixExpandCollapseBar>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                <Size2MixSection title="Production et contrats de combustibles" {...bind('production')}>
                    <Size2MixSimpleTable
                        headerHeight={50} rowHeight={42} wrapHeaderText={false}
                        columns={[
                            { key: 'site', label: 'Site de production', width: 150 }, { key: 'name', label: 'Chaudière', width: 150 },
                            { key: 'priority', label: 'Priorité', width: 150 }, { key: 'fuelContract', label: 'Contrats de combustible', width: 150 },
                            { key: 'defaultPrice', label: 'Prix par défaut', width: 150 },
                        ]}
                        rows={SNAPSHOT_UNITS}
                    />
                </Size2MixSection>
                <Size2MixSection title="Pompes de distribution en site de production" {...bind('pumps')}>
                    <Size2MixSimpleTable headerHeight={50} rowHeight={42} wrapHeaderText={false}
                        columns={[
                            { key: 'site', label: 'Site de production', width: 150 }, { key: 'pumpGroup', label: 'Groupe de pompes', width: 150 },
                            { key: 'pump', label: 'Pompe', width: 150 }, { key: 'type', label: 'Type', width: 150 },
                            { key: 'speed', label: 'Vitesse de rotation minimale (tr/min)', width: 150, render: () => '-' },
                        ]}
                        rows={TEST_PUC_PRODUCTION.pumps}
                    />
                </Size2MixSection>
                <Size2MixSection title="Contraintes sur les contrats de combustible" {...bind('fuels')}>
                    <Size2MixSimpleTable headerHeight={50} rowHeight={42} wrapHeaderText={false}
                        columns={[
                            { key: 'name', label: 'Contrats de combustible', width: 150 },
                            { key: 'calorificValue', label: 'Valeur calorifique [J/quantité]', width: 150 },
                            { key: 'year', label: "Démarrage de l'année comb", width: 150, render: () => '' },
                            { key: 'day', label: 'Démarrage de la journée comb', width: 150, render: () => '' },
                            { key: 'min', label: 'Min horaire', width: 150, render: () => '' },
                        ]}
                        rows={TEST_PUC_PRODUCTION.fuelContracts}
                    />
                </Size2MixSection>
            </div>
            <p role="note">Instantané de {detail.summary.name} : seules les colonnes relevées sont reproduites ; les colonnes hors capture ne sont pas inventées.</p>
        </>
    );
}
